import type { DataType } from './DataPrimitive';
import type { DataPoint } from './DataPoint';
import type { DataFrame } from './DataFrame';
import type { DataSeries } from './DataSeries';
import type { DataSeriesLite } from './DataSeriesLite';

export interface Dimensions {
    [key: string]: IDimension;
}

export type IDimension<T extends DataType = DataType> =
    | DataPoint<T>
    | DataSeries<T>
    | DataSeriesLite<T>
    | DataFrame<T>;
